// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react'
import Typography from '@mui/material/Typography'

function SidebarHeader ({ style, children, ...props }) {
  return (
    <Typography sx={{ padding: '13px 5px 13px 16px', color: 'lightsteelblue', ...style }} {...props}>
      {children}
    </Typography>
  )
}

export default SidebarHeader
